/**
 * Suggested next questions.
 *
 * Derived from what the reader has actually studied rather than written into
 * the source, because a fixed list stops being useful the moment someone has
 * used the app once — and the whole point of an opening screen is to be useful
 * *to this reader*, not to a hypothetical one.
 */

import { z } from "zod";

export const SUGGESTION_GROUPS = [
  "continue",
  "go-deeper",
  "connect",
  "test-yourself",
] as const;

export type SuggestionGroup = (typeof SUGGESTION_GROUPS)[number];

export const GROUP_LABELS: Readonly<Record<SuggestionGroup, string>> = {
  continue: "Pick up where you left off",
  "go-deeper": "Go deeper",
  connect: "Connect what you know",
  "test-yourself": "Test yourself",
};

/** Groups render in this order; the reader's own thread comes first. */
export const GROUP_ORDER: readonly SuggestionGroup[] = SUGGESTION_GROUPS;

export const suggestionSchema = z.object({
  group: z.enum(SUGGESTION_GROUPS),
  /** The button text — a real question, short enough to scan. */
  label: z.string().min(8).max(110),
  /** What actually gets sent when it is clicked. */
  prompt: z.string().min(20).max(1200),
});

export type Suggestion = z.infer<typeof suggestionSchema>;

export const suggestionsSchema = z.object({
  suggestions: z.array(suggestionSchema).min(1).max(8),
});

export interface SuggestionsPayload {
  readonly suggestions: readonly Suggestion[];
  /** False when these are the cold-start seeds rather than derived from history. */
  readonly personalized: boolean;
}
